import React, { useEffect } from 'react';

import Column from 'components/common/Column';
import Text from 'components/common/Text';
import InputForm from 'containers/Login/components/InputForm';
import { EMAIL_REGEX } from 'utils/regExp';

interface HostEmailInputIProps {
  email: string;
  isExistEmail?: boolean;
  handleCheckExistEmail?: (email: string) => void;
  handleChangeSignupParam: (key: string, value: string) => void;
}

// 소셜 계정에서 이메일을 받지 못한 경우 호스트 가입 전에 이메일을 입력받는다
const HostEmailInput: React.FC<HostEmailInputIProps> = props => {
  const {
    email,
    isExistEmail,
    handleCheckExistEmail,
    handleChangeSignupParam,
  } = props;

  // 이메일 입력이 끝나면 가입 버튼을 누르기 전에 중복 여부를 미리 보여준다
  useEffect(() => {
    if (!handleCheckExistEmail || !EMAIL_REGEX.test(email)) {
      return;
    }

    const timer = setTimeout(() => handleCheckExistEmail(email), 500);

    return () => clearTimeout(timer);
  }, [email]);

  return (
    <Column gap="8px" align="flex-start">
      <Column gap="4px" align="flex-start">
        <Text color="#1B1C1E" size="16px" weight={600}>
          이메일
        </Text>
        <Text color="#70737c" size="14px" weight={400}>
          세금계산서 발행 및 주요 안내를 받을 이메일 주소를 입력해 주세요.
        </Text>
      </Column>
      <InputForm
        type="text"
        styleType="large"
        label="이메일을 입력해 주세요"
        target="email"
        regExp={EMAIL_REGEX}
        inputValue={email}
        onChange={handleChangeSignupParam}
      />
      {email !== '' && !EMAIL_REGEX.test(email) && (
        <Text color="#FF4242" size="12px" weight={400}>
          올바른 이메일 주소를 입력해 주세요.
        </Text>
      )}
      {EMAIL_REGEX.test(email) && isExistEmail && (
        <Text color="#FF4242" size="12px" weight={400}>
          이미 가입된 이메일입니다.
        </Text>
      )}
    </Column>
  );
};

export default HostEmailInput;
